<template>
  <div class="d-inline" style="width: 100%; background: blue">
    <v-row no-gutters style="display: flex; flex-direction: row">
      <!-- HeaderLemApp -->

      <!-- Router View -->
      <v-col
        cols="12"
        lg="12"
        sm="12"
        md="12"
        style="position: relative; left: 0px"
      >
        <v-main class="main">
          <router-view />
        </v-main>
      </v-col>

     
      <!-- fin componente izquierdo -->

      <!-- inicio componente derecha -->
      <div
        style="
          position: absolute;
          right: 20px;
          top: 15px;
          z-index: 130;
          border: none;          
        "
      >
        <ButtonSubMenuTwo />
      </div>
      <!-- fin componente derecha -->
    </v-row>
  </div>
</template>

<script>
import HeaderLemApp from "../components/common/HeaderLemApp.vue";
import MenuItemVue from "../components/MenuItem";

import ButtonSubMenuTwo from "../components/menuDial/ButtonSubMenuTwo.vue";

export default {
  components: {
    ButtonSubMenuTwo,
    HeaderLemApp,
    MenuItemVue,
  },
};
</script>

<style scoped>
.main{
  padding: 0px; 
  height: calc(100vh - 55px ); 
}
.rightItemContainer {
  left: 50vw;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  flex-grow: inherit;

  align-content: center;
  align-items: center;

  height: 101vh;
  width: 24.5vw;
  background-color: #256e5f;
  opacity: 0.9;
}
</style>